import { render, staticRenderFns } from "./summary-resolution.vue?vue&type=template&id=52d1830b&"
import script from "./summary-resolution.vue?vue&type=script&lang=js&"
export * from "./summary-resolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports